<template>
    <div class="print">
        <div class="box" v-for="(item,index) in printData" :key="index">
            <div class="title">Detailed Bundle Tally</div>
            <div class="top clearfix">
                <div class="left">
                    <div class="leftC">Date:{{item.date|dateFormat}}</div>
                    <div class="leftC">User:{{item.user}}</div>
                </div>
                <div class="right">Page {{index+1}} of {{printData.length}}</div>
            </div>
            <div class="SOLBox clearfix">
                <div class="sol">Shipment:{{item.shipment}}</div>
                <div class="sol">Order:{{item.order}}</div>
                <div class="sol">Location:{{item.location}}</div>
            </div>
            <div class="listBox">
                <div class="list" v-for="(list,listIndex) in item.bales" :key="listIndex">
                    <div class="listMessage clearfix">
                        <div class="message">Bundle:{{list.bundle}}</div>
                        <div class="message">Species:{{list.species}}</div>
                        <div class="message">Thickness:{{list.thickness}}</div>
                        <div class="message">Dryness:{{list.dryness}}</div>
                        <div class="message">Grade:{{list.grade}}</div>
                    </div>
                    <div class="clearfix detailParent">
                        <div class="detailBox">
                            <div class="detail">
                                <div class="detailLength">Length</div>
                                <div class="detailC" v-for="childIndex of 23" :key="childIndex">{{childIndex+2}}"</div>
                                <div class="detailCTitle">PCS</div>
                                <div class="detailCTitle">BF</div>
                                <div class="detailCTitle">M3</div>
                            </div>
                            <div class="detail" v-for="(sheet,sheetIndex) in list.sheets" :key="sheetIndex">
                                <div class="detailLength">{{sheet.length}}'</div>
                                <!-- <div class="detailThickness">{{sheet.thickness}}</div> -->
                                <div class="detailC" v-for="childIndex of 23" :key="childIndex">{{sheet['width'+(childIndex+2)]==0?'':sheet['width'+(childIndex+2)]}}</div>
                                <div class="detailCTitle">{{sheet.pcs}}</div>
                                <div class="detailCTitle">{{sheet.bf}}</div>
                                <div class="detailCTitle">{{sheet.cube}}</div>
                            </div>
                            <div class="total">
                                <div class="totalC">Avg Length:{{list.avg_length}}</div>
                                <div class="totalC">Avg Width:{{list.avg_width}}</div>
                                <div class="calTotal clearfix">
                                    <div class="calTotalC">{{list.pcs}}</div>
                                    <div class="calTotalC">{{list.bf}}</div>
                                    <div class="calTotalC">{{list.cube}}</div>
                                </div>
                                <div class="totalC detailTotal">TOTALS</div>
                            </div>
                        </div>
                        <div class="calBox">
                            <!-- <div class="calTitle clearfix">
                                <div class="calTitleC">PCS</div>
                                <div class="calTitleC">BF</div>
                                <div class="calTitleC">M3</div>
                            </div> -->
                            <!-- <div class="calTotal clearfix">
                                <div class="calTotalC">{{list.pcs}}</div>
                                <div class="calTotalC">{{list.bf}}</div>
                                <div class="calTotalC">{{list.cube}}</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="end" v-if="(index+1)>=printData.length">****END OF REPORT****</div>
        </div>
    </div>
</template>
<style scoped>
    .print{position: relative;min-height: 100vh;box-sizing: border-box;}
    .box{margin-top:20px;page-break-after: always;}
    .title{width:100%;text-align: center;font-size: 15px;color:#000;font-weight: 600;padding:10px 0;}
    .top{margin-bottom:10px;}
    .top .left{float: left;}
    .top .leftC{font-size: 12px;color:#000;font-weight: 600;}
    .top .right{float:right;font-size: 12px;}
    .SOLBox{padding: 10px 0;border-top:1px solid #000;border-bottom:2px solid #000;}
    .sol{font-size: 13px;color:#000;width:33%;float: left;}
    .listBox{}
    .listBox .list{border-bottom:2px solid #000;}
    .listMessage{padding:10px 20px;}
    .message{width:20%;float: left;font-size: 12px;color:#000;}
    .detailParent{position: relative;}
    .detailBox{float: left;width:100%;box-sizing: border-box;padding-left:80px;}
    .detail{display: flex;width:100%;position: relative;}
    .detailC{font-size: 12px;color:#000;flex:1;padding:2px 0;white-space: nowrap;}
    .detailLength{font-size: 12px;color:#000;position: absolute;left:-60px;top:0;}
    .detailThickness{font-size: 12px;color:#000;position: absolute;left:-40px;top:0;}
    .detailCTitle{font-size: 12px;color:#000;flex-basis:40px;padding:2px 0;}
    .total{float: left;width:100%;box-sizing: border-box;padding-left:50px;}
    .totalC{font-size: 12px;color:#000;float: left;padding:5px 0;margin-right:30px;}
    .detailTotal{float: right;}
    .calBox{width:200px;}
    .calTitle{}
    .calTitleC{font-size: 12px;color:#000;float: left;width:66px;}
    .calTotal{float: right;}
    .calTotalC{font-size: 12px;color:#000;float: left;width:40px;padding:5px 0;}
    .end{font-size: 16px;color:#000;font-weight: 600;text-align: center;padding:5px 0;}
</style>
<script>
export default {
    data(){
        return{
            printData:[],
            id:"",
            type:"",
            print_id:"",
        }
    },
    created(){
        document.title = "谱木云";
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.print_id = this.$route.query.print_id;
        this.print()
    },
    methods:{
        print(){
            let ids = this.id.split(",");
            this.postFunc("/erp/inventory.sheet.print",{ids:ids,type:this.type,print_id:this.print_id},res=>{
                this.printData = res.data.data;
                setTimeout(() => {
                    this.printFunc()
                }, 0);
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        printFunc(){
            setTimeout(() => {
                if(!!window.netscape){
                    window.print()
                    setTimeout(()=>{window.close()}, 0);
                }else{
                    var tata=document.execCommand("print");
                    if(tata){  //点击取消后执行的操作
                        window.close()
                    }
                }
            }, 0);
        },
    },
}
</script>
